import React from "react";
import { useLocation } from "react-router-dom";
import logo from "@/assets/logo/logo-icon.png";
import TextLogo from "@/assets/logo/text-logo.png";
import { OtherLinks, PersonalLinks, SidebarLinks } from "@/constant";
import SidebarLink from "./SidebarLink";
import { SidebarGenerator } from "@/utils/sidebarGenerator";
import CommunityIcon from "@/assets/icons/Community.svg";
import profile from "@/assets/images/profile.png";
import SignOutIcon from "@/assets/icons/SignOutIcon.svg";
import { useAppDispatch, useAppSelector } from "@/redux/hooks/hooks";
import { logOut } from "@/redux/feature/auth/authSlice";
// import Community from "@/pages/community/community";
import { useGetMeQuery } from "@/redux/feature/user/userApi";
import ActiveIcon from "@/assets/icons/ActiveUserIcon.svg";
import { getInitials } from "../../../utils/getFirstTwoLetter";
import { TUser } from "@/types/types";

export type SideBarProps = {
  isExpanded?: boolean;
  setExpanded?: React.Dispatch<React.SetStateAction<boolean>>;
};

const SideBar = ({ setExpanded, isExpanded }: SideBarProps) => {
  const location = useLocation();
  const pathname = location.pathname;
  const { user } = useAppSelector((state) => state.auth);
  const { data } = useGetMeQuery(user?.email);
  const userData: TUser | undefined = data?.data;

  const splitUserName = userData?.fullName
    ? getInitials(userData.fullName)
    : "";

  return (
    <>
      {/* Desktop Sidebar */}
      <div className="hidden md:flex flex-col h-screen py-6 px-3">
        <div
          onClick={() => setExpanded?.(!isExpanded)}
          className="px-3 flex items-center gap-x-2 cursor-pointer py-[10px]"
        >
          <img src={logo} alt="passionbits-logo" />
          {isExpanded && <img src={TextLogo} alt="text-logo" />}
        </div>

        <div className="mt-3 flex-1 h-full overflow-y-scroll">
          <ul className="">
            {SidebarGenerator(SidebarLinks).map((item, i) => (
              <SidebarLink
                isExpanded={isExpanded}
                pathname={pathname}
                data={item}
                key={i}
              />
            ))}
          </ul>
          <div className="border-t border-[#EAEBED] mt-3 pt-3">
            <ul>
              {SidebarGenerator(OtherLinks).map((item, i) => (
                <SidebarLink
                  isExpanded={isExpanded}
                  pathname={pathname}
                  data={item}
                  key={i}
                />
              ))}
            </ul>
          </div>
        </div>
        <div className="">
          <div
            id="sidebar-user-profile"
            className="mt-3 border-t border-[#EAEBED] flex h-[58px] gap-x-2 py-3 px-2 items-center"
          >
            <div>
              {userData?.profilePicture ? (
                <div className="relative">
                  <div className="w-8 h-8">
                    <img
                      className="w-full h-full object-cover rounded-full"
                      src={userData.profilePicture}
                      alt="profile"
                    />
                  </div>
                  <div className="absolute -bottom-[2px] -right-[3px]">
                    <ActiveIcon />
                  </div>
                </div>
              ) : (
                <div className="size-8 flex justify-center items-center text-[#17457D] rounded-full text-sm font-semibold leading-5 relative bg-[#17457D0F]">
                  {splitUserName}
                  <div className="absolute -bottom-[2px] -right-[3px]">
                    <ActiveIcon />
                  </div>
                </div>
              )}
            </div>
            <div
              className={`${
                isExpanded ? "" : " w-[0px]"
              }  whitespace-nowrap overflow-hidden`}
            >
              <h2 className="text-[14px] whitespace-nowrap font-medium">
                {userData?.fullName}
              </h2>
              <p className="text-[#98A2B3] text-xs leading-3 font-normal truncate">
                {userData?.email}
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SideBar;

interface SignOutButtonProps {
  isExpanded: boolean;
}

const SignOutButton: React.FC<SignOutButtonProps> = ({ isExpanded }) => {
  const dispatch = useAppDispatch();
  const handleLogout = () => dispatch(logOut());

  return (
    <li className="h-[70px] md:h-[40px]">
      <button
        onClick={handleLogout}
        className={`mt-3 px-4 py-2 flex h-full md:justify-start justify-center flex-col md:flex-row gap-x-1 w-full items-center transform ease-in-out transition-all text-[#62636C] bg-white border-none`}
      >
        <div className="w-[20px]">
          <SignOutIcon />
        </div>
        {isExpanded && (
          <p
            className={`${
              isExpanded ? "opacity-100" : "w-[0px] opacity-0"
            } whitespace-nowrap transform ease-in-out transition-all duration-300 font-medium text-sm leading-5 tracking-[-0.75%]`}
          >
            Sign out
          </p>
        )}
        <p className="whitespace-nowrap font-medium text-xs mt-1 block md:hidden">
          Sign out
        </p>
      </button>
    </li>
  );
};
